import { useRouter } from 'next/router';

export const hasHidePolygon = (path: string) => {
    const DRAW_POLYGON_REGEX = /hidePoly=true/;

    return DRAW_POLYGON_REGEX.test(path);
};

export const useHasHidePolygon = () => {
    const { asPath } = useRouter();

    return hasHidePolygon(asPath);
};
